/**
 * Ítem 4: D/H (USD) — misma columna; sin tint de fila (ingreso o egreso).
 * Run: npx tsx --test src/modules/CajaBancos/cierreDetalleUsd.test.ts
 */
import { parseArgentineDecimal } from "@/lib/parseArgentineDecimal";
import { roundToPeso } from "@/lib/roundToPeso";

export type UsdRowTone = "ingreso" | "egreso";

export type DetalleUsdLike = {
  tipo?: string | null;
  monedaLinea?: string | null;
  moneda_linea?: string | null;
  esIngreso?: boolean;
  es_ingreso?: boolean;
  montoUsd?: number | string | null;
  monto_usd?: number | string | null;
};

function num(value: unknown): number {
  if (value === null || value === undefined || value === "") return 0;
  const n = Number(value);
  return Number.isNaN(n) ? 0 : n;
}

export function detalleEsUsd(mov: DetalleUsdLike): boolean {
  const moneda = String(mov.monedaLinea ?? mov.moneda_linea ?? "").toUpperCase();
  return moneda === "USD" || mov.tipo === "cobro_usd";
}

export function detalleUsdAmount(mov: DetalleUsdLike): number {
  return num(mov.montoUsd ?? mov.monto_usd);
}

export function detalleEsIngreso(mov: DetalleUsdLike): boolean {
  return Boolean(mov.esIngreso ?? mov.es_ingreso);
}

/** null = fila ARS (sin pintar la fila entera). */
export function usdRowTone(mov: DetalleUsdLike): UsdRowTone | null {
  if (!detalleEsUsd(mov)) return null;
  return detalleEsIngreso(mov) ? "ingreso" : "egreso";
}

/** Siempre vacío: no pintar la fila por tipo (ingreso/egreso). */
export function usdRowClassName(_tone: UsdRowTone | null): string {
  return "";
}

/** Monto a mostrar en D/H (USD); 0 → celda vacía. */
export function usdDhDisplayAmount(mov: DetalleUsdLike): number {
  if (!detalleEsUsd(mov)) return 0;
  return detalleUsdAmount(mov);
}

export function tasaIngresada(raw: string): number | null {
  try {
    const n = parseArgentineDecimal(raw);
    return n != null && n > 0 ? n : null;
  } catch {
    return null;
  }
}

/** Pesos ÷ tipo de cambio, al peso, igual que el cobro en dólares de una venta. */
export function dolaresDesdePesos(importeArs: number, tasa: number): number {
  if (!(importeArs > 0) || !(tasa > 0)) return 0;
  return roundToPeso(importeArs / tasa);
}
